import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../Components/Login/auth.service'
import '../../../styles/pages/MenuDireito/modal/ModalFuncaoEPermissao.css'
//const uuidv4 = require('uuid/v4')

export default function ModalClassificacao() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    var user = authService.getCurrentUser()
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  function handleInputChange(event) {
    if (event.target.name === 'clsStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  let newDate = new Date()
  const [campos, setCampos] = useState({
    IdClassificacao: 0,
    IdEmpresa: user[0].IdEmpresa,
    clsDescricao: '',
    clsObservacoes: '',
    clsStatus: 1,
    clsCriadoPor: user[0].pesEmail,
    clsCriadoEm: newDate,
    clsAlteradoPor: user[0].pesEmail,
    clsAlteradoEm: newDate,
    clsCodigoGUID: uuidv4
  })
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/classificacao', campos)
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes">
        Nova Classificação
      </button>

      {modal && (
        <div className="modalEquipe">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1 className="titleModal">
                Nova Classificação
                <hr className="hrTitleModal" />
              </h1>
              <button className="close-modal" onClick={toggleModal}>
                X
              </button>
            </div>
            <form onSubmit={handleFormSubmit}>
              <label>Descrição:</label>
              <input
                type="text"
                id="fname"
                defaultValue={campos.clsDescricao}
                name="clsDescricao"
                onChange={handleInputChange}
              ></input>

              <label>Observações:</label>
              <textarea
                type="text"
                id="fname"
                defaultValue={campos.clsObservacoes}
                name="clsObservacoes"
                onChange={handleInputChange}
                row="none"
                maxLength="500"
              ></textarea>
              <div className="caixaSalvarPadrao">
                <div className="InputAuthorization4">
                  <label>
                    <input
                      name="txtStatus"
                      type="checkbox"
                      defaultChecked={!!campos.clsStatus}
                      onChange={handleInputChange}
                    />
                    <span>Status</span>
                  </label>
                </div>

                <button type="submit">Salvar Registro</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
